//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            form: new Form({
                salutation: '',
                company: null,
                vatin: null,
                firstname: null,
                lastname: null,
                street: null,
                postalCode: null,
                city: null,
                country: '',
                email: null,
                email_confirmation: null
            }),
            countries: []
        };
    },


    methods: {
        formGroupClass: function formGroupClass(name) {
            return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
        }
    },

    created: function created() {
        var _this = this;

        this.countries = App.countries;
        App.event.listen('countries.loaded', function (countries) {
            return _this.countries = countries;
        });

        //- register user
        App.event.listen('guest.send', function () {
            _this.form.put('/guest').then(function (response) {
                App.event.fire('guest.success', response);
            }).catch(function (errors) {
                App.event.fire('guest.failed', errors);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/guest/components/Guest.vue
// module id = FmhP
// module chunks = 4